import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate';
import PageTracker from '../../../../common/PageTrackerHelper'


export default {
  name: 'shipmentScanTallyAuditNew',
  components: {
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        hubname : '',
        toDate : '',
        hubServiceCenterList : [],
        Include : '',
        exclude : '',
        comments : '',
        shippingId : '',
        shipmentDetailsFlag : false,
        scanShipmentBatchFlag : false,
        showBatchesFlag : false,
        shipmentStatusType : '',
        commentsObjList : [
          {"comments":"Box Found Empty"},
          {"comments":"Box Found Damaged - Product Damaged"},
          {"comments":"Box Found Open/Tempered - Product Mismatch"},
          {"comments":"AWB Barcode Unreadable – Manually Entered"},
          {"comments":"Box Found Repacked"},
          {"comments":"Security Pouch Tempered"},
          {"comments":"Security Pouch Missing"},
        ],
        excludeList : [{"eId":"OFD","excludeName":"OFD Shipments"}],
        IncludeList : [{"IncludeId":"BagIn","IncludeName":"BagIn Shipments"}]
      }
  },
  created: function() {
    this.getHubList();
  },
  mounted(){
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail[0].userid;
    this.localusermailid = userdetail[0].email;
    this.createdBy = userdetail.username;
    this.userid = userdetail.userid;
  },
  methods : {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          let generateBatch = {
            "hubName" : this.hubname,
            "bDate" : this.toDate,
          }
          console.log('Payload',generateBatch);
          this.scanShipmentBatchFlag = true;
          this.showBatchesFlag = true;
          // axios({
          //     method: 'POST',
          //     'url': apiUrl.api_url + '',
          //     'data': generateBatch
          // })
          // .then(result => {
          //     console.log('Result :',result);
          // ,error => {
          //     console.error(error)
          // })
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getHubList(){
       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList =response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
    },
    showBatch(){
      this.showBatchesFlag = true;
    },
    exportShipmentData(){
      console.log('export data');
    },
    scanShipments(){
      this.scanShipmentBatchFlag = true;
    },
    shipmentScanTally(typeName){
      this.shipmentStatusType = typeName;
      this.shipmentDetailsFlag = true;
    },
    clear(){
      this.hubname = '';
      this.toDate = '';
      this.Include = '';
      this.exclude = '';
      this.scanShipmentBatchFlag = false;
      this.shipmentDetailsFlag = false
      this.showBatchesFlag = false;
      this.$validator.reset();
      this.errors.clear();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ScanTally/shipmentScanTallyAuditNew/shipmentScanTallyAuditNew.component.js